import React from "react";
import Launch from '@nerdwallet/react-icon/material/Launch';
import { getFederallyInsuredAnnotation, getIssuerName, getMonetizationStatus } from '@nerdwallet/marketplace/selectors/banking';

var getAnnotationText = function getAnnotationText(offer, hideInstitutionFromAnnotation) {
  var federallyInsuredAnnotation = getFederallyInsuredAnnotation(offer);
  var displayName = getIssuerName(offer);

  if (hideInstitutionFromAnnotation === true) {
    return federallyInsuredAnnotation || '';
  }

  if (federallyInsuredAnnotation) {
    return "at ".concat(displayName, ", ").concat(federallyInsuredAnnotation);
  }

  return "at ".concat(displayName);
};

export default (function (_ref) {
  var className = _ref.className,
      _ref$disableAnnotatio = _ref.disableAnnotation,
      disableAnnotation = _ref$disableAnnotatio === void 0 ? false : _ref$disableAnnotatio,
      _ref$disableBankCtaAn = _ref.disableBankCtaAnnotation,
      disableBankCtaAnnotation = _ref$disableBankCtaAn === void 0 ? false : _ref$disableBankCtaAn,
      displayPage = _ref.displayPage,
      marketplaceEntity = _ref.marketplaceEntity,
      _ref$hideInstitutionF = _ref.hideInstitutionFromAnnotation,
      hideInstitutionFromAnnotation = _ref$hideInstitutionF === void 0 ? false : _ref$hideInstitutionF;
  return {
    annotationText: disableAnnotation || disableBankCtaAnnotation ? '' : getAnnotationText(marketplaceEntity, hideInstitutionFromAnnotation),
    classNameApplyNow: className,
    icon: /*#__PURE__*/React.createElement(Launch, {
      textAligned: true,
      size: 16
    }),
    monetizable: getMonetizationStatus(marketplaceEntity),
    offer: marketplaceEntity,
    pageType: displayPage,
    vertical: 'Banking Rate',
    text: 'Learn More'
  };
});